import React, { useEffect, useState } from "react"
import JastipForm from "./JastipForm"
import { getJastip, updateJastip, updateJastipImage } from "services/jastipService"
import { useParams } from "react-router"
import { Button, Card, CardContent, Grid, MenuItem, Select, Switch } from "@mui/material";
import { WBLabel, WBTitleLabel } from "components/_WBcomponents/WBLabel"
import moment from "moment"
import { currencyFormat } from "helper/numberHelper"
import { isSuperAdmin } from "helper/localStorage"
import { WBInput } from "components/_WBcomponents/WBInput"
import { regexNumber } from "helper/constant"
import { NumericFormat } from "react-number-format";
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { CFGRecapInvoice } from "components/_WBcomponents/Invoice_CFG";
import html2pdf from "html2pdf.js";
import DropZoneComponent from "components/_WBcomponents/DropzoneComponent";
import { handleUpload } from "helper/S3";
import CustomerDropDown from "components/_WBcomponents/CustomerDropDown";

function JastipInfo({

}) {

    const { id } = useParams()
    const [detail, setDetail] = useState({
        orderCode: '',
        createdDate: null,
        custName: '',
        custPhoneNumber: '',
        addressDetail: '',
        shoppingRequest: [],
        additionalFee: [],
        qtyType: '',
        dp: null
    })
    const [shoppingRequest, setShoppingRequest] = useState({
        name: "",
        image: "",
        qty: 1, // default 1 because not set type
        qtyType: "",
        price: "",
        totalPrice: "",
        grandTotalPrice: ""
    })
    const [additionalFee, setAdditionalFee] = useState({
        information: "",
        totalPrice: ""
    })
    const [loading, setLoading] = useState(false)
    const [closeDropDown, setCloseDropDown] = useState(false)
    const [onAllowFilter, setOnAllowFilter] = useState(false)

    useEffect(() => {
        loadDetailJastip()
    }, [])

    const onChangeShopping = (e) => {
        setShoppingRequest(prev => ({
            ...prev,
            ...e
        }))
    }

    const addShoppingRequest = async () => {
        try {
            setShoppingRequest({
                name: "",
                image: "",
                qty: 1, // default 1 because not set type
                qtyType: "",
                price: "",
                totalPrice: "",
            })
            onChange({
                shoppingRequest: [...detail.shoppingRequest, shoppingRequest]
            })
        } catch (error) {
            console.log(error)
        }
    }

    const deleteJastip = (index) => {
        let shoppingRequest = detail.shoppingRequest
        shoppingRequest.splice(index, 1);
        onChange({ shoppingRequest: shoppingRequest })
    }

    const loadDetailJastip = async () => {
        setLoading(true)
        console.log('here jastip id', id)
        let { data, error } = await getJastip({ id })
        console.log(data)
        setLoading(false)
        if (!data) { }
        setDetail({
            ...data,
            totalPrice: data.jastipTotal,
            grandTotalPrice: data.totalPrice
        })
    }

    const onChangeAdditionalFee = (e) => {
        setAdditionalFee(prev => ({
            ...prev,
            ...e
        }))
    }

    const addAdditonalFee = async () => {
        try {
            setAdditionalFee({
                information: "",
                totalPrice: "",
            })
            onChange({
                additionalFee: [...detail.additionalFee, additionalFee]
            })
        } catch (error) {
            console.log(error)
        }
    }

    const deleteAdditionalFee = async (index) => {
        detail.additionalFee.splice(index, 1)
        onChange({
            additionalFee: detail.additionalFee
        })
    }

    const saveUpdateJastip = async () => {
        let images = []
        for (let i = 0; i < detail.images.length; i++) {
            if (detail.images[i].name) {
                let currImages = await handleUpload({
                    selectedFile: detail.images[i],
                    dirName: 'product'
                })
                images.push(currImages[0])
            } else {
                images.push(detail.images[i])
            }
        }
        if (!isSuperAdmin()) {
            let { data, error } = await updateJastipImage({
                id: detail._id,
                images
            })
            console.log('here data', data, error)
            if (error) { console.log(error) }
            if (data) { alert("Success"); loadDetailJastip() }
            return;
        }
        if (isSuperAdmin()) {
            let { data, error } = await updateJastip({
                id: detail._id,
                ...detail,
                images
            })
            if (error) { console.log(error) }
            if (data) { alert("Success"); loadDetailJastip() }
        }
    }

    const onChange = (e) => {
        setDetail(prev => ({
            ...prev,
            ...e
        }))
    }

    const deleteAddonImages = (index) => {
        let currImages = detail.images
        currImages.splice(index, 1);
        onChange({ images: currImages })
    }

    const generatePDF = async () => {
        let filename = `${detail.custName.replace(' ', '_')}_${moment(detail.createdDate).format('DDMMYYYYHHmm')}.pdf`
        let pdf = await html2pdf().set({
            margin: [-0.5, 0],
            filename: filename,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                allowTaint: true,
                letterRendering: true,
                logging: false,
                scale: 2
            },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        }).from(CFGRecapInvoice({ data: detail })).save();
    }

    return (
        <Grid onClick={() => {
            setCloseDropDown(true)
        }}>
            <Card>
                <CardContent>
                    <Grid container style={{
                        alignItems: 'center'
                    }}>
                        <Grid item xs={6}>
                            <WBTitleLabel bold>{detail.orderCode}</WBTitleLabel>
                            <WBLabel>{moment(detail.createdDate).format('DD/MM/YYYY HH:mm:ss')}</WBLabel>
                        </Grid>
                        {/* {
                            isSuperAdmin() &&
                            <Grid item xs={6} textAlign={"right"} style={{
                                cursor: 'pointer'
                            }}>
                                <WBLabel style={{fontSize: 10}} onClick={() => {  
                                    // var printWindow = window.open('', '', 'height=400,width=800');
                                    // printWindow.document.write(CFGRecapInvoice());
                                    // printWindow.print();        
                                    generatePDF()
                                }}><DownloadIcon/></WBLabel>
                            </Grid>
                        } */}
                        <Grid item xs={6} textAlign={"right"} style={{
                            cursor: 'pointer'
                        }}>
                            <WBLabel style={{ fontSize: 10 }} onClick={() => {
                                // var printWindow = window.open('', '', 'height=400,width=800');
                                // printWindow.document.write(CFGRecapInvoice());
                                // printWindow.print();        
                                generatePDF()
                            }}><DownloadIcon /></WBLabel>
                        </Grid>
                    </Grid>
                    <Grid container mt={0.5} spacing={1}>
                        <Grid item>
                            {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                            <WBInput label={"Customer name"} disabled={!isSuperAdmin()} value={detail.custName} />
                            {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                            {/* <WBInput label={"Phone Number"} onChange={(e) => {
                                onChange({custPhoneNumber: e.currentTarget.value})
                            }} value={detail.custPhoneNumber}/>
                            <WBLabel bold>{detail.addressDetail ? detail.addressDetail.streetName : ''}</WBLabel> */}
                        </Grid>
                        {
                            isSuperAdmin() &&
                            <Grid item>
                                {/* <WBLabel style={{ color: 'white' }}>{"-"}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                                <WBInput label={"Phone Number"} onChange={(e) => {
                                    onChange({ custPhoneNumber: e.currentTarget.value })
                                    setOnAllowFilter(true)
                                }} value={detail.custPhoneNumber} />
                                {
                                    onAllowFilter &&
                                    <CustomerDropDown
                                        phoneNumber={detail.custPhoneNumber}
                                        closeDropDown={closeDropDown}
                                        setCloseDropDown={(e) => { setCloseDropDown(e) }}
                                        onChange={(e) => { onChange(e) }}
                                        setAllowFilter={(e) => { setOnAllowFilter(e) }}
                                        excludeName
                                    />
                                }
                            </Grid>
                        }
                    </Grid>
                    <Grid container>
                        {
                            isSuperAdmin() &&
                            <Grid item xs={12} lg={6}>
                                {/* <WBLabel style={{ color: 'white' }}>{"-"}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                                <WBInput type={"textarea"} label={"Customer Address"} onChange={(e) => {
                                    onChange({
                                        addressDetail: {
                                            streetName: e.currentTarget.value.toUpperCase()
                                        }
                                    })
                                }} value={detail.addressDetail.streetName} />
                            </Grid>
                        }
                    </Grid>
                    {/* <Grid container mt={2}>
                        <WBLabel bold style={{ fontSize: 14 }}>Total : {currencyFormat(detail.totalPrice)}</WBLabel>
                    </Grid> */}
                </CardContent>
            </Card>
            <Card sx={{ mt: 2 }}>
                <CardContent>
                    <Grid mb={1}>
                        <div><WBLabel bold style={{ fontSize: 16 }}>Jastip Image :</WBLabel></div>
                    </Grid>
                    {
                        (detail.images && detail.images.length > 0) &&
                        <Grid container mt={2}>
                            {
                                detail.images.map(v => {
                                    return (
                                        <Grid item>
                                            <img src={v} style={{ width: '100px', height: 'auto' }} />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    }
                    <DropZoneComponent
                        className="drop-zone"
                        uploadName='addonImage'
                        file={detail.images}
                        isMultiple={true}
                        onDrop={(files) => {
                            // if (files.length >= 4) { return; }
                            let currImages = detail.images ? detail.images : []
                            for (let i = 0; i < files.length; i++) {
                                currImages = currImages.concat(files[i])
                            }
                            onChange({ images: currImages })
                        }}
                    >
                        <div className='dropzone mb-0' style={{
                            textAlign: 'center',
                            minHeight: '150px'
                        }}>
                            <div style={{ padding: 10, alignItems: 'center' }}>
                                <label>
                                    <i className='fa fa-upload mr-1' />
                                    Drop itemImages to upload
                                </label>
                                <br />
                                <br />
                                <label
                                    htmlFor={"addonImage"}
                                    style={{ cursor: 'pointer' }}
                                    className='dropzone-child mb-0'>
                                    or Click to Browse
                                </label>
                                <div style={{ overflowX: 'auto' }}>
                                    {
                                        detail.images &&
                                        <div style={{ textAlign: 'left' }}>
                                            Uploaded file :
                                            <div className='d-flex'>
                                                {
                                                    detail.images.map((value, index) => {
                                                        return (
                                                            <div key={`${value.name}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                                                <img src={(!value.name && value.includes("https")) ? value : URL.createObjectURL(value)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                                                    onClick={() => { }}
                                                                />
                                                                <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                                                    {value.name}
                                                                    <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                                                        deleteAddonImages(index)
                                                                    }}>X</span>
                                                                </label>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </DropZoneComponent>
                </CardContent>
            </Card>
            {
                isSuperAdmin() &&
                <Card sx={{
                    mt: 2
                }}>
                    <CardContent>
                        <Grid mb={1}>
                            <div><WBLabel bold style={{ fontSize: 16 }}>Shopping Total :</WBLabel></div>
                        </Grid>
                        <Grid container item xs={12} md={12} spacing={1}>
                            <Grid item xs={8} sm={2} md={2} lg={2}>
                                <WBInput label={"Qty / Weight"} onChange={(e) => {
                                    if (!regexNumber(e.currentTarget.value)) { return }
                                    onChange({
                                        qty: e.currentTarget.value,
                                        totalPrice: e.currentTarget.value * detail.price
                                    })
                                }} value={detail.qty}
                                />
                            </Grid>
                            <Grid item >
                                <Select
                                    sx={{
                                        marginTop: 2.2,
                                        borderRadius: 2,
                                        height: 41,
                                        minWidth: 80,
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#2196f3", // #d8f0e9 #64a591
                                            },
                                            "&:hover fieldset": {
                                                borderColor: '#2196f3',
                                            },
                                            "&.Mui-disabled input": {
                                                backgroundColor: "#f5f5f5"
                                            }
                                        },
                                    }}
                                    value={detail.qtyType}
                                    onChange={(e) => {
                                        console.log(e)
                                        onChange({ qtyType: e.target.value })
                                    }}
                                // input={<WBInput />}
                                >
                                    {["kg", "pcs"].map((name) => (
                                        <MenuItem key={name} value={name}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price {detail.qtyType ? `/${detail.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={detail.price}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChange({
                                            price: value.replace(/^0+/, ''),
                                            totalPrice: value.replace(/^0+/, '') * detail.qty
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Total Price</WBLabel>
                                <NumericFormat
                                    value={detail.totalPrice}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChange({ totalPrice: value.replace(/^0+/, '') })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            }
            {
                isSuperAdmin() &&
                <Card sx={{
                    mt: 2
                }}>
                    <CardContent>
                        <Grid item xs={12} mb={1}>
                            <div><WBLabel bold style={{ fontSize: 16 }}>DP :</WBLabel></div>
                        </Grid>
                        <Grid container alignItems={"center"}>
                            <Grid item container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                    <WBLabel style={{
                                        color: "rgb(133, 133, 133)"
                                    }}>Input DP Value</WBLabel>
                                    <NumericFormat
                                        value={detail.dp}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            // if (form.couponType.value == "percentage") { 
                                            //     if (floatValue > 100) { return false }
                                            // }
                                            return true
                                        }}
                                        onValueChange={(values) => {
                                            const { formattedValue, value, floatValue } = values;
                                            // do something with floatValue
                                            onChange({ dp: value.replace(/^0+/, '') })
                                        }}
                                        // disabled={form._id}
                                        decimalScale={0}
                                        allowLeadingZeros={false}
                                        allowedDecimalSeparators={false}
                                        allowNegative={false}
                                        thousandSeparator
                                        customInput={WBInput}
                                    />
                                </Grid>
                                <Grid item>
                                    <WBLabel style={{
                                        color: "rgb(133, 133, 133)"
                                    }}>DP Paid</WBLabel>
                                    <Switch checked={detail.dpPaid} onChange={() => {
                                        onChange({ dpPaid: !detail.dpPaid })
                                    }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            }
            {
                isSuperAdmin() &&
                <Card sx={{
                    mt: 2
                }}>
                    <CardContent>
                        <Grid item mb={1}>
                            <Grid item xs={12}><WBLabel bold style={{ fontSize: 16 }}>Discount :</WBLabel></Grid>
                            <Grid item container xs={12}>
                                <Grid item xs={12}>
                                    <WBLabel style={{
                                        color: "rgb(133, 133, 133)"
                                    }}>Input Discount</WBLabel>
                                    <Grid item xs={12} md={3} lg={3}>
                                        <NumericFormat
                                            value={detail.discount}
                                            isAllowed={(values) => {
                                                const { floatValue } = values;
                                                // if (form.couponType.value == "percentage") { 
                                                //     if (floatValue > 100) { return false }
                                                // }
                                                return true
                                            }}
                                            onValueChange={(values) => {
                                                const { formattedValue, value, floatValue } = values;
                                                // do something with floatValue
                                                onChange({ discount: value.replace(/^0+/, '') })
                                            }}
                                            // disabled={form._id}
                                            decimalScale={0}
                                            allowLeadingZeros={false}
                                            allowedDecimalSeparators={false}
                                            allowNegative={false}
                                            thousandSeparator
                                            customInput={WBInput}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            }
            <Card sx={{ mt: 2 }}>
                <CardContent>
                    <Grid mb={1}>
                        <div><WBLabel bold style={{ fontSize: 16 }}>Jastip Request :</WBLabel></div>
                    </Grid>
                    {
                        isSuperAdmin() &&
                        <Grid container spacing={2} xs={12} md={9}>
                            <Grid item xs={12} md={6} lg={3.3}>
                                <WBInput label={"Product Name"} onChange={(e) => {
                                    onChangeShopping({ name: e.currentTarget.value.toUpperCase() })
                                }} value={shoppingRequest.name} />
                            </Grid>
                            {/* <Grid item xs={8} md={4.5} lg={1.5}>
                                <WBInput label={"Qty / Weight"} onChange={(e) => {
                                    if (!regexNumber(e.currentTarget.value)) { return }
                                    onChangeShopping({
                                        qty: e.currentTarget.value,
                                        totalPrice: e.currentTarget.value * shoppingRequest.price
                                    })
                                }}  value={shoppingRequest.qty}/>
                            </Grid>
                            <Grid item xs={4} md={1.5} lg={1.5}>
                                <Select 
                                    sx={{
                                        marginTop: 2.2,
                                        borderRadius: 2,
                                        height: 41,
                                        minWidth: 80,
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#2196f3", // #d8f0e9 #64a591
                                            },
                                            "&:hover fieldset": {
                                                borderColor: '#2196f3',
                                            },
                                            "&.Mui-disabled input": {
                                                backgroundColor: "#f5f5f5"
                                            }
                                        },
                                    }}
                                    value={shoppingRequest.qtyType}
                                    onChange={(e) => {
                                        console.log(e)
                                        onChangeShopping({qtyType: e.target.value})
                                    }}
                                    // input={<WBInput />}
                                >
                                    {["kg", "pcs"].map((name) => (
                                        <MenuItem key={name} value={name}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid> */}
                            <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={shoppingRequest.price}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChangeShopping({
                                            price: value.replace(/^0+/, ''),
                                            totalPrice: value.replace(/^0+/, '') * shoppingRequest.qty
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Total Price</WBLabel>
                                <NumericFormat value={shoppingRequest.totalPrice}
                                    isAllowed={(values) => {
                                        const {floatValue} = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const {formattedValue, value, floatValue} = values;
                                        // do something with floatValue
                                        onChangeShopping({ totalPrice: value.replace(/^0+/, '') })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid> */}
                            <Grid item xs={12} lg={12} textAlign={"right"}>
                                <Button variant="contained"
                                    disabled={
                                        !shoppingRequest.name ||
                                        !shoppingRequest.qty
                                        // || !shoppingRequest.price
                                    }
                                    onClick={() => {
                                        addShoppingRequest()
                                    }}>Add</Button>
                            </Grid>
                        </Grid>
                    }
                    <Grid container mt={2} spacing={2}>
                        {
                            detail.shoppingRequest.map((value, index) => {
                                return (
                                    <Grid item xs={6} lg={3}>
                                        <Grid container style={{
                                            position: 'relative',
                                            alignItems: 'center'
                                        }}>
                                            {
                                                isSuperAdmin() &&
                                                <Grid sx={{
                                                    position: 'absolute',
                                                    right: 0
                                                }} onClick={() => {
                                                    deleteJastip(index)
                                                }}>
                                                    <DeleteIcon color="black" />
                                                </Grid>
                                            }
                                            <Grid item sx={{
                                                borderLeft: '1px solid red',
                                                paddingLeft: 2,
                                                minHeight: 60
                                            }}>
                                                <WBLabel bold style={{
                                                    fontSize: 14
                                                }}>{value.name}</WBLabel>
                                                {/* <WBLabel>{value.qty} {value.qtyType}</WBLabel> */}
                                                {
                                                    (isSuperAdmin() && value.totalPrice > 0) &&
                                                    <>
                                                        {/* <WBLabel bold>{currencyFormat(value.price)} x {value.qty} {value.qtyType}</WBLabel> */}
                                                        <WBLabel bold>Total Price : {currencyFormat(value.totalPrice)}</WBLabel>
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </CardContent>
            </Card>
            <Card sx={{ mt: 2, mb: 9 }}>
                <CardContent>
                    <Grid mb={1}>
                        <div><WBLabel bold style={{ fontSize: 16 }}>Additional Fee :</WBLabel></div>
                    </Grid>
                    {
                        isSuperAdmin() &&
                        <Grid container spacing={2} xs={12} md={9}>
                            <Grid item xs={12} md={6} lg={3.3}>
                                <WBInput label={"Product Name"} onChange={(e) => {
                                    onChangeAdditionalFee({ information: e.currentTarget.value.toUpperCase() })
                                }} value={additionalFee.information} />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={shoppingRequest.price}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChangeAdditionalFee({
                                            totalPrice: value.replace(/^0+/, '')
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Total Price</WBLabel>
                                <NumericFormat value={shoppingRequest.totalPrice}
                                    isAllowed={(values) => {
                                        const {floatValue} = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const {formattedValue, value, floatValue} = values;
                                        // do something with floatValue
                                        onChangeShopping({ totalPrice: value.replace(/^0+/, '') })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid> */}
                            <Grid item xs={12} lg={12} textAlign={"right"}>
                                <Button variant="contained"
                                    disabled={
                                        !additionalFee.information ||
                                        !additionalFee.totalPrice
                                        // || !shoppingRequest.price
                                    }
                                    onClick={() => {
                                        addAdditonalFee()
                                    }}>Add</Button>
                            </Grid>
                        </Grid>
                    }
                    <Grid container mt={2} spacing={2}>
                        {
                            detail.additionalFee && detail.additionalFee.map((value, index) => {
                                return (
                                    <Grid item xs={6} lg={3}>
                                        <Grid container style={{
                                            position: 'relative',
                                            alignItems: 'center'
                                        }}>
                                            {
                                                isSuperAdmin() &&
                                                <Grid sx={{
                                                    position: 'absolute',
                                                    right: 0
                                                }} onClick={() => {
                                                    deleteAdditionalFee(index)
                                                }}>
                                                    <DeleteIcon color="black" />
                                                </Grid>
                                            }
                                            <Grid item sx={{
                                                borderLeft: '1px solid red',
                                                paddingLeft: 2,
                                                minHeight: 60
                                            }}>
                                                <WBLabel bold style={{
                                                    fontSize: 14
                                                }}>{value.information}</WBLabel>
                                                {/* <WBLabel>{value.qty} {value.qtyType}</WBLabel> */}
                                                {
                                                    (isSuperAdmin() && value.totalPrice > 0) &&
                                                    <>
                                                        {/* <WBLabel bold>{currencyFormat(value.price)} x {value.qty} {value.qtyType}</WBLabel> */}
                                                        <WBLabel bold>Total Price : {currencyFormat(value.totalPrice)}</WBLabel>
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </CardContent>
            </Card>
            {/* <div dangerouslySetInnerHTML={{__html: CFGRecapInvoice()}}/> */}
            <Grid item xs={12} mt={1} textAlign={"right"} style={{
                backgroundColor: 'white',
                width: '100%',
                position: 'fixed',
                bottom: 0,
                padding: 10,
                right: 8
            }}>
                <Button variant="contained"
                    disabled={
                        !detail.custName ||
                        // !form.custPhoneNumber ||
                        !detail.shoppingRequest ||
                        loading
                    }
                    onClick={() => {
                        saveUpdateJastip()
                    }}>Update</Button>
            </Grid>
        </Grid>
    )
}

export default JastipInfo